import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import Special from "@/pages/special/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news-detail/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/category/:type",
        element: <Category />,
      },
      {
        path: "/detail/:id",
        element: <Detail />,
      },
      {
        path: "/special/:id",
        element: <Special />,
      },
      {
        path: "/news",
        element: <News />,
      },
      {
        path: "/news/detail/:id",
        element: <NewsDetail />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;